import { Button } from 'react-bulma-components';
import PropTypes from 'prop-types';

import './button.scss';

const CustomButtonV2 = ({ children, disabled, loading, onClick }) => {
    return (
        <Button className='custom-button' fullwidth disabled={disabled} loading={loading} onClick={onClick}>
            {children}
        </Button>
    );
};

export default CustomButtonV2;

CustomButtonV2.propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onClick: PropTypes.func
};
